var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Captions"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.405 20h45.189c.551 0 1.076-.227 1.454-.627s.574-.938.543-1.488l-.025-.519c-.325-5.252-4.715-9.366-9.996-9.366h-2.57v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-16v-2c0-1.104-.896-2-2-2s-2 .896-2 2v2h-2.57c-5.281 0-9.672 4.115-9.997 9.37l-.025.516c-.032.549.165 1.087.542 1.488s.905.626 1.455.626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.904 25.95c-.026-1.085-.914-1.95-1.999-1.95h-45.81c-1.085 0-1.972.865-2 1.95-.179 7.165-.052 14.305.378 21.224.312 5.02 4.333 9.04 9.351 9.352 5.036.316 10.106.474 15.176.474 5.069 0 10.141-.158 15.174-.475 5.02-.312 9.04-4.333 9.353-9.352.43-6.918.557-14.059.377-21.223zm-14.904 10.05c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3zm3 7c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm-23-3c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm-3-7c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zm10 10c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zm3-7c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderlogo);
export default __webpack_public_path__ + "static/media/calenderlogo.74cc96f4bdc85e22aa961db27bbf8e7d.svg";
export { ForwardRef as ReactComponent };